<template>
  <div style="width:90%">
    <b-list-group >
      這裡是銷售管理
    </b-list-group>
    <b-button @click="getChartData">更新資料</b-button>
    <div class="chart1">
      <g-chart
        type="LineChart"
        :data="chartData"
        :options="chartOptions"
      />
    </div>
    <loading
     :show="Loading.show"
     :label="Loading.label">
    </loading>
  </div>
</template>

<script>

// import {genericApiResult} from "../../api/modules/basic-api"
import { GChart } from 'vue-google-charts'
import loading from 'vue-full-loading'

export default {
  name: 'SalesView',
  components: {
    GChart,
    loading
  },
  data: function () {
    return {
      Loading: {
        'show': false,
        'label': '努力加載中'
      },
      showMsg: false,
      displayingMsg: '',
      chartData: [['111','222','333','444','555','666'],[1,2,3,4,5,6],[3,2,3,4,5,6],[2,2,3,4,5,6]],
      chartOptions: {
        /*width: 780,*/
        height: 280,
        /*chartArea: {
            left: 50,
            top: 50,
            height: 200
        },*/
        //axisTitlesPosition: 'none',
        /*hAxis: {
            format: 'MM/dd',
            gridlines: {
                color: '#E4E4E4',
                count: 7
            }
        },
        vAxis: {
            baselineColor: '#E4E4E4',
            gridlines: {
                color: '#E4E4E4',
                count: 4
            }
        },*/
        series: {
            0: {targetAxisIndex: 0},
            1: {targetAxisIndex: 0},
            2: {targetAxisIndex: 0},
            3: {targetAxisIndex: 0},
            4: {targetAxisIndex: 1}
        },
        vAxes: {
            0: {title: '數量'},
            1: {title: '評分'}
        },
        /*pointSize: 4,
        colors: ['#6C6C6C', '#2E9DF3', '#F3CA42', '#41B9AE', '#E20055']*/
      }
    }
  },
  props: [
      'MsgItems'
    ],
  methods: {
    loadMsg: function () {
      alert('load msg')
    },
    cancel: function () {
      this.CancelCallback();
    },
    PopupDisplay: function (msg) {
      this.displayingMsg = msg
      this.showMsg = true;
    },
    /*onChartReady: function (chart, google) {
      let data = new google.visualization.DataTable();
      // let data = google.visualization.arrayToDataTable(this.chartData)
      // eslint-disable-next-line
      console.log(data)
      let columns = [
        {name: 'Date', type: 'date'},
        {name: '開放預約數', type: 'number'},
        {name: '銷售數', type: 'number'},
        {name: '退票數', type: 'number'},
        {name: '使用數', type: 'number'},
        {name: '平均評價數', type: 'number'}
      ]
      for (let i=0; i< columns.length; i++) {
        data.addColumn(columns[i].type, columns[i].name);
      }
      data.addRows({'Date':'2018-01-01','開放預約數':1,'開放預約數':1,'開放預約數':1,'開放預約數':1,'開放預約數':1})
      //$.each(columns, function(i, column) {
      //  data.addColumn(column.type, column.name);
      //});
      // data.addRows(this.chartData);
      chart.draw(data, this.chartOptions)
    },*/
    getChartData: function () {
      this.Loading.show = true
      let rptParam = {
        'module':'merchant',
        'method':'getAdminProductPerformanceView',
        'report_start_date':'2018-04-15',
        'report_ned_date':'2018-09-18',
        'gchart_mode':1
      }
      this.$bus.apiCall(rptParam, function (data, vm) {
        if (data.ok === 0) {
            alert(data.msg)
            vm.Loading.show = false
            return
          }
          // eslint-disable-next-line
          // console.log(data)
          vm.chartData = data.data.chart_view
          vm.Loading.show = false
      },this)
    }
  },
  computed: {
    
  },
  mounted () {
    this.getChartData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chart1 {
  width:100%;
  height:280px;
}
</style>
